import React from 'react';

import { useIntl } from 'ha/i18n';
import {
  FurnitureFilterValue,
  FurnitureValue,
  FurnitureFilterCount,
} from 'ha/types/SearchFilters';

import CommonCheckboxFilter from './CommonCheckboxFilter';
import CommonCheckboxTitleWithCount from './CommonCheckboxTitleWithCount';

interface Props {
  value: FurnitureFilterValue;
  onChange: (value: FurnitureFilterValue) => void;
  count?: FurnitureFilterCount;
}

const FurnitureFilter: React.FC<Props> = ({ value, onChange, count }) => {
  const { T } = useIntl();

  return (
    <CommonCheckboxFilter
      value={value}
      onChange={onChange}
      options={[
        {
          value: FurnitureValue.FURNISHED,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Furnished')}
              count={count?.furnished}
            />
          ),
          testLocator: 'Filter Furnished',
        },
        {
          value: FurnitureValue.UNFURNISHED,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Unfurnished')}
              count={count?.unfurnished}
            />
          ),
          testLocator: 'Filter Unfurnished',
        },
      ]}
    />
  );
};

export default FurnitureFilter;
